<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <!--
        A page that is a document rather than a screen: no navigation, no branding,
        no width of its own — the sheet inside decides how wide the paper is.

        It exists because `Blank` does not. `Blank` is the login card: a centred
        `max-w-sm` column with the product's name over it, which is right for a sign-in
        form and wrong for an invoice — an A4 sheet asked for 210 mm and was given
        384 px, so the document came out as a till receipt with the amounts cut off.
        Rather than teach one layout two jobs, the desk's printable documents get their
        own: `Default` is the application, `Blank` is the card, this is the paper.
    -->
    <div class="min-h-screen bg-muted print:min-h-0 print:bg-transparent">
        <slot>
            <RouterView />
        </slot>
    </div>
</template>

<script lang="ts" setup>
</script>
